import type { LanguageType } from "@/types/LanguageTypes";

/**
 * Get display label for a language in listboxes.
 * Rule: Show only language_name (e.g. "English", "Dutch") by default.
 * Exception: When user has multiple variants of the same language (e.g. en-US and en-UK),
 * show "English (US)", "English (UK)" to differentiate.
 * Same for all language listboxes.
 */
export function getLanguageDisplayLabel(
  lang: LanguageType,
  allLanguagesInContext: LanguageType[]
): string {
  const sameNameCount = allLanguagesInContext.filter(
    (l) => l.language_name === lang.language_name
  ).length;

  if (sameNameCount > 1) {
    const region = lang.country_code || extractRegionFromLocale(lang.locale_code);
    return region ? `${lang.language_name} (${region})` : lang.language_name;
  }

  return lang.language_name;
}

function extractRegionFromLocale(localeCode: string): string {
  const parts = localeCode.split("-");
  return parts.length > 1 ? parts[parts.length - 1] : "";
}
